var _defs, _path, _path2, _circle, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowerRainNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efcc00;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:none;stroke:#0baeff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(-1, 0, 0, 1, -378.03, 0)",
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient",
    x1: -397.28,
    x2: -418.37,
    y1: 52.39,
    y2: 25.08
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0, -1, -1, 0, 103.42, -388.95)",
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient-2",
    x1: -430.14,
    x2: -418.52,
    y1: 51.15,
    y2: 68.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,20.71A13.88,13.88,0,0,1,37.86,2.77.6.6,0,0,0,37,2.08,13.88,13.88,0,1,0,55.92,21a.6.6,0,0,0-.69-.89A13.91,13.91,0,0,1,50,20.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.66,15.9a17.49,17.49,0,0,1,15.47,9.32A13.75,13.75,0,1,1,46,50.84l-22.39.06a17.5,17.5,0,0,1,0-35Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 46.05,
    cy: 37.09,
    r: 13.75,
    transform: "translate(-2.06 71.46) rotate(-74.39)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 32.5,
    x2: 32.5,
    y1: 55.5,
    y2: 56.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.5,
    x2: 26.5,
    y1: 53.5,
    y2: 54.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 38.5,
    x2: 38.5,
    y1: 53.5,
    y2: 54.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 38.5,
    x2: 38.5,
    y1: 59.5,
    y2: 60.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 26.5,
    x2: 26.5,
    y1: 59.5,
    y2: 60.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 32.5,
    x2: 32.5,
    y1: 61.5,
    y2: 62.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerRainNight);
export default __webpack_public_path__ + "static/media/shower_rain_night.f62c0fb5325ee9de9783a28fc5f95265.svg";
export { ForwardRef as ReactComponent };